<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    :fill="fill"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 14.6654H4.66667C3.93029 14.6654 3.33333 14.0684 3.33333 13.332V4.66536H2V3.33203H4.66667V2.66536C4.66667 1.92898 5.26362 1.33203 6 1.33203H10C10.7364 1.33203 11.3333 1.92898 11.3333 2.66536V3.33203H14V4.66536H12.6667V13.332C12.6667 14.0684 12.0697 14.6654 11.3333 14.6654ZM4.66667 4.66536V13.332H11.3333V4.66536H4.66667ZM6 2.66536V3.33203H10V2.66536H6ZM10 11.9987H8.66667V5.9987H10V11.9987ZM7.33333 11.9987H6V5.9987H7.33333V11.9987Z"
      :fill="semanticColorLookup('surface.on-surface')"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconsTrash',
  props: {
    width: {
      type: String,
      default: '16'
    },
    height: {
      type: String,
      default: '16'
    },
    fill: {
      type: String,
      default: 'none'
    }
  }
}
</script>
